import SlimSelect from 'slim-select';

export default {
  methods: {
    selectUpdate(selector, data = undefined, value = undefined) {
      const select = selector.cloneNode ? selector : document.querySelector(selector);
      if (!select) return;
      if (value !== undefined) {
        select.value = value;
      }
      let options = undefined;
      if (data !== undefined) {
        options = JSON.parse(JSON.stringify(data));
        if (select.dataset.placeholder) {
          options.unshift({
            text: select.dataset.placeholder,
            value: '',
            // placeholder: true,
          });
        }
      }
      if (select.slim) {
        select.slim.disable();
        if (data !== undefined) {
          select.slim.setData(options);
        }
        if (value !== undefined) {
          select.slim.setSelected(value);
        }
        select.slim.enable();
      } else {
        initSelect(select, options);
      }
    },
    selectClear(selector, data = undefined, value = '') {
      this.selectUpdate(selector, data, value);
    },
  }
};
